module.exports = __webpack_public_path__ + "static/carbon-dropdown-a1f914d4a87bc16eb610bb845cb86ae3.png";